var ls_update_interval = 1; // in hours
var ls_timeout;
var clickEventType = ( (document.ontouchstart !== null) ? 'click' : 'touchstart' );
var local_zip_codes = ['76240', '76241', '73459'];
var casino_data = {o: {}};
var loginHtml;
var casino_keepalive = 0;

function check_login_status(interval){

  jQuery.ajax({
    url: global_vars.ajax_url,
    type: 'get',
    data : {
      action : 'check_login_status'
    }
  }).done(function(data) {
    var data_obj = JSON.parse(data);

    casino.logged_in = data_obj.logged_in;    
    casino.firstName = data_obj.firstName;

    casino_data.o = casino;

    if(!loginHtml)
    {
      loginHtml = jQuery('#my-newcastle-menu .js-my-newcastle-link > a').html();
    }

    if ( JSON.parse(casino.logged_in) ) {

      jQuery('#my-newcastle-menu .js-my-newcastle-link > a').toggleClass('logged-in', casino.logged_in == "true").html(ejs.compile(jQuery('#tmpl-my-casino-logging-in').html())(casino_data));
      jQuery('.header-mobile .js-header-mobile__profile').toggleClass('logged-in', casino.logged_in == "true");
      jQuery('.header-mobile #loggedin-name').html("Hello, " + casino.firstName);

      if (jQuery('#newcastle-user-menu-wrapper').is(':visible')) {
        if(window.my_casino_disabled)
        {
          jQuery('#newcastle-user-menu-wrapper').html(ejs.compile(jQuery('#tmpl-my-casino-disabled').html())(casino_data));  
        }
        else{
          jQuery('#newcastle-user-menu-wrapper').html(ejs.compile(jQuery('#tmpl-my-casino-popover-content').html())(casino_data));
        }
      }

      if (jQuery('#my-casino-account-page').is(':visible')) {
        jQuery('#my-casino-account-page').html(ejs.compile(jQuery('#tmpl-my-casino-account-content').html())(casino_data));
        
        trigger_window_resize();
      }

      if (jQuery('#my-casino-account-rewards').is(':visible')) {
        jQuery('#my-casino-account-rewards').html(ejs.compile(jQuery('#tmpl-my-casino-account-rewards').html())(casino_data));
      }

      if(!interval)
      {
        populate_casino_data();
      }
      
      clearTimeout(casino_keepalive);
      //Add keep-alive for My Newcastle
      casino_keepalive = setTimeout(function(){ 
        check_login_status(true);
      }, 300000);


    }
    else
    {
      clearTimeout(casino_keepalive);
      jQuery('#my-newcastle-menu .js-my-newcastle-link > a').toggleClass('logged-in', casino.logged_in == "true");
      jQuery('.header-mobile .js-header-mobile__profile').toggleClass('logged-in', casino.logged_in == "true");
      jQuery('#my-newcastle-menu .js-my-newcastle-link > a').html(loginHtml);
      
      if (jQuery('#club_passport_signup_form').is(':visible')) {
        jQuery('#club_passport_signup_form').html(ejs.compile(jQuery('#tmpl-my-casino-club-passport-form').html())(casino_data));
        render_club_passport_form_recaptcha();
      }

      if (jQuery('#my_casino_register_form, #club_passport_signup_form').is(':visible')) {
        dob_calendar_datepicker();
      }
    }

  });

}

check_login_status();

function offers_loaded(response) {
  // count offers elem
  var offers_count = jQuery(response).filter('.js-offer').length;
  if (offers_count == 0) {
    var elem = jQuery(response).find('div.available-count');
    if (elem.length > 0) {
      offers_count = parseInt(elem.html());
    }
  }
  
  jQuery('#my-casino-account-page-head .offers.available-count').html(offers_count);
  jQuery('#my-casino-account-page-head .offers-mobile-dropdown.available-count').html('('+offers_count+')');

  casino.offers = casino.offers || {count: 0};
  if (offers_count !== casino.offers.count) {
    casino.offers.count = offers_count;
    var store_offers = store.get('ls_offers') || {data: {count: 0}};
    store_offers.data = store_offers.data || {count: 0};
    store_offers.data.count = offers_count;
    store.set('ls_offers', store_offers);
    casino_data_updated();
  }
}


function sweepstakes_loaded(response) {
  // count offers elem
  var sweepstakes_count = jQuery(response).filter('.js-sweepstake').length;

  casino.sweepstakes = casino.sweepstakes || {count: 0};
  if (sweepstakes_count !== casino.sweepstakes.count) {
    casino.sweepstakes.count = sweepstakes_count;
    var store_sweepstakes = store.get('ls_sweepstakes') || {data: {count: 0}};
    store_sweepstakes.data = store_sweepstakes.data || {count: 0};
    store_sweepstakes.data.count = sweepstakes_count;
    store.set('ls_sweepstakes', store_sweepstakes);
    casino_data_updated();
  }
}


var storeCompressionPlugin = function() {
	return {
		get: get,
		set: set,
	}

	function get(super_fn, key) {
		var val = super_fn(key)
		if (!val) { return val }
		var decompressed = LZString.decompressFromUTF16(val)
		// fallback to existing values that are not compressed
		return (decompressed == null) ? val : this._deserialize(decompressed)
	}

	function set(super_fn, key, val) {
		var compressed = LZString.compressToUTF16(this._serialize(val))
		super_fn(key, compressed)
	}
}


function allow_account_update_form_editing() {

  var accountType = casino.account_type;

  if ( accountType != 'patron' ) {
    // jQuery('#my_casino_update_account_form').find('input#email').prop('disabled', true);
    // jQuery('#my_casino_update_account_form').find('input#email').addClass('disabled-input');
  } else if ( accountType == 'patron' ) {
    jQuery('#my_casino_update_account_form').find('input:not(#email), select').prop('disabled', true);
    jQuery('#my_casino_update_account_form').find('input:not(#email), select').addClass('disabled-input');
    // jQuery('#my_casino_update_account_form').find('input#email').removeAttr('readonly');
  }

  jQuery('#my-account-update-form button.edit-button').on(clickEventType, function(ev) {
    if ( accountType != 'patron' ) {
      jQuery(this).addClass('edit-active');
      jQuery(this).closest('form').find('button.save-button').removeAttr('disabled');
      jQuery(this).closest('form').find('input, select').removeAttr('disabled');
      jQuery(this).closest('form').find('input:not(#email), select').removeClass('disabled-input');
      jQuery(this).closest('form').find('button.save-button').addClass('save-ready');
      jQuery(this).closest('form').find('.row').removeClass('disabled-input'); // Allows the Preferences form to be accessed
    } else if ( accountType == 'patron' ) {
      jQuery(this).addClass('edit-active');
      jQuery(this).closest('form').find('button.save-button').removeAttr('disabled');
      jQuery(this).closest('form').find('input#email').removeAttr('disabled');
      jQuery(this).closest('form').find('input#email').removeAttr('readonly');
      jQuery(this).closest('form').find('input#email').removeClass('disabled-input');
      jQuery(this).closest('form').find('button.save-button').addClass('save-ready');
      jQuery(this).closest('form').find('.row').removeClass('disabled-input'); // Allows the Preferences form to be accessed

      if (jQuery(this).parents('form#my_casino_change_password_form, #my_casino_change_preferences_form').length > 0 ) {
        jQuery(this).closest('form').find('input').removeAttr('disabled'); // Allows the password change to work for patrons
        jQuery(this).closest('form').find('input:not(#email)').removeClass('disabled-input');
      }
    }
  });
}

function dob_calendar_datepicker() {
  var currentYear = new Date().getFullYear() + 1;
  var maxBirthYear = currentYear - 18;
  var startDate = jQuery('input[id="dob"]').val() || "01/01/1975";

  jQuery('input[id="dob"]').daterangepicker({
    singleDatePicker: true,
    showDropdowns: true,
    minYear: 1901,
    maxYear: maxBirthYear,
    startDate: startDate,
    autoUpdateInput: false
  }, function(start, end, label) {
    jQuery('input[id="dob"]').val(start.format('MM/DD/YYYY'));
  });
}


function casino_data_updated() {
  // console.log('casino_data_updated updating');

  allow_account_update_form_editing();

  casino_data.o = casino;

  jQuery('#my-newcastle-menu .js-my-newcastle-link > a').toggleClass('logged-in', casino.logged_in == "true").html(ejs.compile(jQuery('#tmpl-my-casino-menu-content').html())(casino_data));
  jQuery('.header-mobile .js-header-mobile__profile').toggleClass('logged-in', casino.logged_in == "true");
  if (casino.logged_in == "true" && casino.firstName != "") {
    jQuery('.header-mobile #loggedin-name').html("Hello, " + casino.firstName);
  } else {
    jQuery('.header-mobile #loggedin-name').html();
  }
  
  if (jQuery('#newcastle-user-menu-wrapper').is(':visible')) {
    if(window.my_casino_disabled)
    {
      jQuery('#newcastle-user-menu-wrapper').html(ejs.compile(jQuery('#tmpl-my-casino-disabled').html())(casino_data));  
    }
    else{
      jQuery('#newcastle-user-menu-wrapper').html(ejs.compile(jQuery('#tmpl-my-casino-popover-content').html())(casino_data));
    }
  }

  if (jQuery('#my-casino-account-page').is(':visible')) {
    jQuery('#my-casino-account-page').html(ejs.compile(jQuery('#tmpl-my-casino-account-content').html())(casino_data));
    
    trigger_window_resize();
  }

  if (jQuery('#my-casino-account-rewards').is(':visible')) {
    jQuery('#my-casino-account-rewards').html(ejs.compile(jQuery('#tmpl-my-casino-account-rewards').html())(casino_data));
  }

  var num_offers = casino.offers == undefined ? 0 : casino.offers.count;
  if (jQuery('#my-casino-account-page-head .offers.available-count').length) {
    jQuery('#my-casino-account-page-head .offers.available-count').html(num_offers);
  }
  if (jQuery('#my-casino-account-page-head .offers-mobile-dropdown.available-count').length) {
    jQuery('#my-casino-account-page-head .offers-mobile-dropdown.available-count').html('('+num_offers+')');
  }
  
  send_update_to_hubspot();
  
  if (typeof dataLayer != 'undefined' && casino.patron) {
    dataLayer.push({
      event: 'patronEvent',
      patronLevel: casino.patron.currentCardLevel,
      patronNumber: casino.patron.patronNumber
    });
  }

}


function send_update_to_hubspot() {
  
  try {
    if ( JSON.parse(casino.logged_in) && casino.patron !== undefined && casino.patron.email != null ) {
      var email = casino.patron.email.toLowerCase();
      var firstname = casino.firstName;
      var lastname = casino.lastName;
      var my_casino_account_type = casino.account_type;
      var club_passport_card_level = (casino.patron.currentCardLevel || "").trim();
      var current_offers = casino.offers == undefined ? 0 : casino.offers.count;
      var sweepstakes_entries = casino.sweepstakes == undefined ? 0 : casino.sweepstakes.count;
      var passport_rewards_amount = casino.patron.cashAvailable == '' ? '$0.00' : casino.patron.cashAvailable;
      passport_rewards_amount = parseFloat(passport_rewards_amount.replace('$',''));
      var online_gaming_rewards_points = casino.compcash == '' ? 0 : parseInt(casino.compcash);
      var passport_tier_points = casino.patron.currentPoints == '' ? 0 : parseInt(casino.patron.currentPoints);
      var pointsToNextLevelByDate = casino.patron.pointsToNextLevelByDate;
      if ( pointsToNextLevelByDate != '' ) {
        var yearNum = pointsToNextLevelByDate.substr(0,4);
        var monthNum = pointsToNextLevelByDate.substr(4,5);
        var passport_tier_points_expiration =  monthNum + '/'+ yearNum;
      } else {
        var passport_tier_points_expiration = '';
      }
      
      var host_flag = casino.patron.hostFlag;
      
      var _hsq = window._hsq = window._hsq || [];
      _hsq.push(["identify", {
        email: email,
        firstname: firstname,
        lastname: lastname,
        my_casino_account_type: my_casino_account_type,
        club_passport_card_level: club_passport_card_level,
        current_offers: current_offers,
        sweepstakes_entries: sweepstakes_entries,
        passport_rewards_amount: passport_rewards_amount,
        online_gaming_rewards_points: online_gaming_rewards_points,
        passport_tier_points: passport_tier_points,
        passport_tier_points_expiration: passport_tier_points_expiration,
        host_flag: host_flag
      }]);
    }
    
  } catch(err) {
    // ignore
    console.log(err);
  }
  
}


function update_casino_variable_and_local_storage(reloadFlag, reloadId) {
  // console.log('update_casino_variable_and_local_storage() initiated...');
  
  clear_scheduled_data_update();
  
  // var ls = new SecureLS();
  var ls = store;
  
  var ls_username = ls.get('ls_username');
  
  // console.log(ls_username);
  
  if (casino.username != ls_username) {
    ls.remove('ls_patron');
    ls.remove('ls_offers');
    ls.remove('ls_compcash');
    ls.remove('ls_sweepstakes');
    
    ls.set('ls_username', casino.username);
    ls.set('ls_last_updated_at', moment().subtract(1, 'day'));
  }
  
  var now = moment();
  var last_updated_at = ls.get('ls_last_updated_at') == '' ? moment().subtract(1, 'day') : moment(ls.get('ls_last_updated_at'));
  var data_updated = false;
  
  var ls_patron = ls.get('ls_patron');

  // update casino variable with patron info
  if ( ls_patron !== undefined && ls_patron.data !== undefined && JSON.stringify(casino.patron) !== JSON.stringify(ls_patron.data) ) {
    casino.patron = ls_patron.data;
    data_updated = true;
  }

  if (casino.account_type == 'patron') {

    var ls_offers = ls.get('ls_offers');

    // update casino variable with offers info
    if ( ls_offers !== undefined && ls_offers.data !== undefined && JSON.stringify(casino.offers) !== JSON.stringify(ls_offers.data) ) {
      casino.offers = ls_offers.data;
      data_updated = true;
    }

    var ls_sweepstakes = ls.get('ls_sweepstakes');

    // update casino variable with offers info
    if ( ls_sweepstakes !== undefined && ls_sweepstakes.data !== undefined && JSON.stringify(casino.sweepstakes) !== JSON.stringify(ls_sweepstakes.data) ) {
      casino.sweepstakes = ls_sweepstakes.data;
      data_updated = true;
    }

    var ls_compcash = ls.get('ls_compcash');

    // update casino variable with offers info
    if ( ls_compcash !== undefined && ls_compcash.data !== undefined && JSON.stringify(casino.compcash) !== JSON.stringify(ls_compcash.data) ) {
      casino.compcash = ls_compcash.data;
      data_updated = true;
    }

  } else {
    
    if ( casino.sweepstakes !== null ) {
      casino.sweepstakes = null;
      data_updated = true;
    }

    if ( casino.offers !== null ) {
      casino.offers = null;
      data_updated = true;
    }

    if ( casino.compcash !== null ) {
      casino.compcash = null;
      data_updated = true;
    }  
    
  }
  
  if (data_updated) {
    // trigger data update on page
    casino_data_updated();
  }

  if (casino.account_type == 'patron') {
     
    if ( now.isAfter(last_updated_at.add(ls_update_interval, 'hour')) ) {
      
      clear_scheduled_data_update();
      
      var patron_fn = jQuery.ajax({
        url: global_vars.ajax_url,
        type: 'post',
        data : {
          action : 'my_casino_get_patron_as_json'
        }
      });
    
      var offers_fn = jQuery.ajax({
        url: global_vars.ajax_url,
        type: 'post',
        data : {
          action : 'get_offers'
        }
      });
      
      var sweepstakes_fn = jQuery.ajax({
        url: global_vars.ajax_url,
        type: 'post',
        data : {
          action : 'get_sweepstakes'
        }
      });
      
      var compcash_fn = jQuery.ajax({
        url: global_vars.ajax_url,
        type: 'post',
        data : {
          action : 'get_comp_cash_balance'
        }
      });
      
      jQuery.when( patron_fn, offers_fn, sweepstakes_fn, compcash_fn ).done( function( patron_resp, offers_resp, sweepstakes_resp, comcash_resp ) {
        // console.log('promise done');
        
        // Each resp argument is an array with the following structure: [ data, statusText, jqXHR ]
        var patron_resp_data = JSON.parse(patron_resp[0]);
        if (patron_resp_data.success == true) {
          // add/update LS
          ls.set('ls_patron', {data: patron_resp_data.data});

          // add/update in casino variable
          casino.patron = patron_resp_data.data;
          
        }

        var offers_resp_data = JSON.parse(offers_resp[0]);
        if (offers_resp_data.success == true) {
          // add/update LS
          ls.set('ls_offers', {data: offers_resp_data.data});

          // add/update in casino variable
          casino.offers = offers_resp_data.data;
        }

        var sweepstakes_resp_data = JSON.parse(sweepstakes_resp[0]);
        if (sweepstakes_resp_data.success == true) {
          // add/update LS
          ls.set('ls_sweepstakes', {data: sweepstakes_resp_data.data});

          // add/update in casino variable
          casino.sweepstakes = sweepstakes_resp_data.data;
        }

        var comcash_resp_data = JSON.parse(comcash_resp[0]);
        if (comcash_resp_data.success == true) {
          // add/update LS
          ls.set('ls_compcash', {data: comcash_resp_data.data});

          // add/update in casino variable
          casino.compcash = comcash_resp_data.data;
        }

        ls.set('ls_last_updated_at', moment());

        // trigger data update on page
        casino_data_updated();

        schedule_my_casino_data_update();

        if ( reloadFlag === true && reloadId !== undefined ) {
          window.location.hash = reloadId;
          window.location.reload(true);
        }

      });
      
    } else {

      schedule_my_casino_data_update();
      
    }
    
  } else {
      
    if ( now.isAfter(last_updated_at.add(ls_update_interval, 'hour')) ) {
      
      clear_scheduled_data_update();
      
      jQuery.ajax({
        url: global_vars.ajax_url,
        type: 'post',
        data : {
          action : 'my_casino_get_patron_as_json'
        },
        success: function(json) {
          resp = JSON.parse(json);
          if (resp.success == true) {

            // add/update LS
            ls.set('ls_patron', {data: resp.data});
            ls.set('ls_last_updated_at', moment());

            // add/update in casino variable
            casino.patron = resp.data;
            
            // trigger data update on page
            casino_data_updated();

            schedule_my_casino_data_update();            
          }
        }
      });
    
    } else {
      
      schedule_my_casino_data_update();
      
    }

    ls.remove('ls_offers');
    ls.remove('ls_compcash');
    ls.remove('ls_sweepstakes');
    
  }
}

function schedule_my_casino_data_update() {
  clear_scheduled_data_update();
  ls_timeout = setTimeout(function() { 
    // update_casino_variable_and_local_storage();
    check_login_status();
  }, 300000);
}

function clear_scheduled_data_update() {
  if ( ls_timeout !== undefined ) {
    clearTimeout(ls_timeout);
  }
}

function cleanup_casino_variable() {
  
  // remove my casino data from local variable 'casino'
  casino.patron = null;
  casino.sweepstakes = null;
  casino.offers = null;
  casino.compcash = null;
  
}

function populate_casino_data() {
  
  jQuery.ajax({
    url: global_vars.ajax_url,
    type: 'get',
    data : {
      action : 'get_casino_data'
    }
  }).done(function(data) {
    var data_obj = JSON.parse(data);
    
    casino.logged_in = data_obj.logged_in;
    casino.account_type = data_obj.account_type;
    casino.username = data_obj.username;
    casino.firstName = data_obj.firstName;
    casino.lastName = data_obj.lastName;
    
    casino_data.o = casino;

    if ( JSON.parse(casino.logged_in) ) {
      update_casino_variable_and_local_storage();

      if (jQuery('#club_passport_signup_form').is(':visible')) {
        jQuery('#club_passport_signup_form').html(ejs.compile(jQuery('#tmpl-my-casino-club-passport-form').html())(casino_data));
        render_club_passport_form_recaptcha();
      }

      if (jQuery('#my-account-update-form').is(':visible')) {
        jQuery('#my-account-update-form').html(ejs.compile(jQuery('#tmpl-my-account-update-form').html())(casino_data));
        allow_account_update_form_editing();
        dob_calendar_datepicker();
      }

      // Auto selects the user's state in the reel rewards form
      if ( jQuery('#club_passport_signup_form, #my_casino_update_account_form').length > 0 ) {
        if ( casino.patron !== undefined ) {

          var userState = casino.patron.state;

          jQuery('#state option').each(function(index) {
            if ( userState == jQuery(this).val() ) {
              jQuery(this).prop('selected', 'selected');
            }
          });
      
        }
      }

      jQuery('#my-newcastle-menu .js-my-newcastle-link > a').prop("style", "pointer-events: all");
      jQuery('#my-newcastle-menu .js-my-newcastle-link > a').removeClass("hide-caret");
      
    } else {
      cleanup_casino_variable();
      clear_scheduled_data_update();
      
      if (jQuery('#club_passport_signup_form').is(':visible')) {
        jQuery('#club_passport_signup_form').html(ejs.compile(jQuery('#tmpl-my-casino-club-passport-form').html())(casino_data));
        render_club_passport_form_recaptcha();
      }
      
      if ( JSON.parse(data_obj.force_reload) ) {
        location.reload();
      }
      
    }
    
    if (jQuery('#my_casino_register_form, #club_passport_signup_form').is(':visible')) {
      dob_calendar_datepicker();
    }
    
  });
  
}

var captchaId, popupCaptchaId;

function render_club_passport_form_recaptcha() {
  
  captchaId = grecaptcha.render('club-passport-recaptcha', {});
  
}

function render_popover_link_account_forms_recaptcha() {
  
  if (jQuery('#popover-prospect-link-account-recaptcha').is(':visible')) {
    popupCaptchaId = grecaptcha.render('popover-prospect-link-account-recaptcha', {});
  }
  if (jQuery('#popover-np-link-account-recaptcha').is(':visible')) {
    popupCaptchaId = grecaptcha.render('popover-np-link-account-recaptcha', {});
  }
  
}


jQuery(document).on('click', "#my-newcastle-menu .js-subscribe-link > a, #my-newcastle-menu .js-my-newcastle-link > a, #my-newcastle-menu .js-book-now-link > a, #my-newcastle-menu .js-social-media-link > a, .disable-click",  function(e){
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
});



jQuery(document).ready(function($){
  
  store.addPlugin(storeCompressionPlugin);

	$(document).on('click', ".js-my-casino-signout",  function(e){
    e.preventDefault();
    
    if (JSON.parse(casino.logged_in)) {
      var elem = $(this);

      var ls = store;

      ls.remove('ls_last_updated_at');
      ls.remove('ls_username');
      ls.remove('ls_patron');
      ls.remove('ls_offers');
      ls.remove('ls_compcash');
      ls.remove('ls_sweepstakes');

      $.ajax({
        url: global_vars.ajax_url,
        data : {
          action : 'casinoLogout'
        },
        success: function() {
          // window.location.reload();
          if (typeof dataLayer != 'undefined') {
            dataLayer.push({
              event: 'loginEvent',
              loginState: false
            });
          }

          document.location.href = "/";
        }
      });
    }

	});
  
  $('#my-newcastle-menu .js-my-newcastle-link > a').attr('tabindex', '0');

  $(document).on('submit', 'form#my_casino_change_preferences_form', function(e) {

      // if form has hubspot guid, send it to hubspot
      if ( $("form#my_casino_change_preferences_form input[name=hubspot_form_guid]").length > 0 && $("form#my_casino_change_preferences_form input[name=hubspot_form_guid]").val().length > 0 ) {
        
        $.ajax({
          url: global_vars.ajax_url, 
          data: $("form#my_casino_change_preferences_form").serialize(),
          type: "POST",             
          cache: false,             
          processData: false,
          beforeSend : function(xhr) {
            $('form#my_casino_change_preferences_form #error_message').html('');
            $('form#my_casino_change_preferences_form #response_message').html('');
            $('form#my_casino_change_preferences_form button#save_preferences').addClass('loading').prop('disabled', true);
          },
          success: function(data) {

            if($.trim(data) == "success") {
              $('form#my_casino_change_preferences_form #response_message').show();
              $('form#my_casino_change_preferences_form button#save_preferences').removeClass('loading').prop('disabled', false);
              $('form#my_casino_change_preferences_form button#update_preferences').removeClass("edit-active");

              $('form#my_casino_change_preferences_form #response_message').html('- Updated Successfully');

              setTimeout(function(){ 
                $('form#my_casino_change_preferences_form #response_message').fadeOut(3000);
              }, 3000);
            } else {
              $('form#my_casino_change_preferences_form button#save_preferences').removeClass('loading').prop('disabled', false);
              $('form#my_casino_change_preferences_form button#save_preferences').prop("disabled",null);
              $('form#my_casino_change_preferences_form #error_message').html('- Error Occurred - Please Try Again Later');
            }
          }
        }).fail(function (jqXHR, textStatus, error) {
          $('form#my_casino_change_preferences_form button#save_preferences').removeClass('loading').prop('disabled', false);
          $('form#my_casino_change_preferences_form button#save_preferences').prop("disabled",null);
          $('form#my_casino_change_preferences_form #error_message').html('- Error Occurred - Please Try Again Later');
        });
        
      }

    e.preventDefault();
  });
  
  // Enables my newcastle user menu popover
  $('#my-newcastle-menu .js-my-newcastle-link > a').popover({
      html : true, 
      content: function() {
        if(window.my_casino_disabled)
        {
          return ejs.compile(jQuery('#tmpl-my-casino-disabled').html())(casino_data);  
        }
        else{
          return ejs.compile(jQuery('#tmpl-my-casino-popover-content').html())(casino_data);
        }
      },
      placement: 'bottom',
      offset: '0, 7px',
      // boundary: 'viewport',
      trigger: 'click',
      container: '#my-newcastle-menu .js-my-newcastle-link',
      template: '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-body d-flex" id="newcastle-user-menu-wrapper"></div></div>'
  });

  var bookNowElement = $("#book-now-menu-content").prop('outerHTML');
  // Enables the Book Now menu popover
  $('#my-newcastle-menu .js-book-now-link > a').popover({
      html: true, 
      content: function() {
        return bookNowElement;
      },
      placement: 'bottom',
      offset: '0, 7px',
      trigger: 'click',
      container: '#my-newcastle-menu .js-book-now-link',
      template: '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-body d-flex" id="book-now-menu-wrapper"></div></div>'
  });

  // Enables the Book Now menu popover for mobile
  $('.header-mobile__menu-btn__book > a').popover({
      html: true, 
      content: function() {
        return bookNowElement;
      },
      placement: 'bottom',
      offset: '0, 0',
      trigger: 'click',
      container: '.header-mobile__menu-btn__book',
      template: '<div class="popover popover-mobile-book" role="tooltip"><div class="arrow"></div><div class="popover-body" id="book-now-menu-wrapper"></div></div>'
  });

  // Enables my newcastle user menu popover for mobile
  $('.js-header-mobile__profile').popover({
      html : true, 
      content: function() {
        if(window.my_casino_disabled)
        {
          return ejs.compile(jQuery('#tmpl-my-casino-disabled').html())(casino_data);  
        }
        
        return ejs.compile(jQuery('#tmpl-my-casino-popover-content').html())(casino_data);
      },
      placement: 'bottom',
      //offset: '0, 20px',
      trigger: 'click',
      container: 'body',
      template: '<div class="popover header-mobile__my-newcastle-popover d-lg-none" role="tooltip"><div class="arrow"></div><div class="popover-body" id="newcastle-user-menu-wrapper"></div></div>'
  });

  // Enables the Social Media menu popover
  $('#my-newcastle-menu .js-social-media-link > a').popover({
      html: true, 
      content: function() {
        return $("#social-media-menu-content")[0];
      },
      placement: 'bottom',
      offset: '0, 20px',
      trigger: 'click',
      container: '#my-newcastle-menu .js-social-media-link',
      template: '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-body" id="social-media-menu-wrapper"></div></div>'
  });

  var subscribeElement = $("#subscribe-menu-content").prop('outerHTML');
  $("#subscribe-menu-content").remove();

  // Enables the Subscribe menu popover
  $('#my-newcastle-menu .js-subscribe-link > a').popover({
      html: true, 
      content: function() {
        return subscribeElement;
      },
      placement: 'bottom',
      offset: '0, 7px',
      trigger: 'click',
      container: '#my-newcastle-menu .js-subscribe-link',
      template: '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-body d-flex" id="subscribe-menu-wrapper"></div></div>'
  });

  // Enables the Subscribe menu popover for mobile
  $('.header-mobile__menu-btn__subscribe > a').popover({
      html: true, 
      content: function() {
        return subscribeElement;
      },
      placement: 'bottom',
      offset: '0, 0',
      trigger: 'click',
      container: '.header-mobile__menu-btn__subscribe',
      template: '<div class="popover popover-mobile-subscribe" role="tooltip"><div class="arrow"></div><div class="popover-body" id="subscribe-menu-wrapper"></div></div>'
  });

  // Closes popovers after a click anywhere outside the popover
  $(document).on('click', function(e) {
    $('.popover').each(function() {
      if ( !$(this).is(e.target)
          && $(this).has(e.target).length === 0
          && $('.popover').has(e.target).length === 0
          && !$(e.target).hasClass('nav-link')
          && !$(e.target).hasClass('my-casino-logged-in')
          && !$(e.target).hasClass('text-truncate')
          && !$(e.target).hasClass('try-again')
          && !$('.header-mobile').is(':visible')
          && !$(e.target).parent().is(".next, .prev") 
          && !$(e.target).parent().parent().is(".next, .prev") 
          && !$(e.target).is(".next, .prev") ) {
        ( ($(this).popover('hide').data('bs.popover')||{}).inState||{} ).click = false;
      }
    });
  });

  $('.js-my-newcastle-link, .js-book-now-link').on('show.bs.popover', function(){
    $('.header-mobile .popover').popover('hide');
  });

  $('.js-header-mobile__profile, .js-header-mobile__book').on('show.bs.popover', function(){
    $('#my-newcastle-menu .popover').popover('hide');
    window.resetMenu(true);
  });

  $('.js-header-mobile__profile').on('shown.bs.popover', function(){
    $('body').addClass('mobile-menu-active');
  });
  
  $('.js-header-mobile__profile').on('hide.bs.popover', function(){
    $('body').removeClass('mobile-menu-active');
    window.resetMenu(false, "my-newcastle");
  });

  function popover_re_captcha_verified(){
    if (jQuery('#prospect_club_passport_popup').is(':visible')) {
      $('form#prospect_club_passport_popup .recaptcha-msg-error').text('');
      $('form#prospect_club_passport_popup .recaptcha-msg-error').removeClass( "error" );
    }
    if (jQuery('#non_patron_club_passport_popup').is(':visible')) {
      $('form#non_patron_club_passport_popup .recaptcha-msg-error').text('');
      $('form#non_patron_club_passport_popup .recaptcha-msg-error').removeClass( "error" );
    }
  } 

  window.popover_re_captcha_verified = popover_re_captcha_verified;

  $('#my-newcastle-menu .js-my-newcastle-link > a, .js-header-mobile__profile').on('shown.bs.popover', function() {
    // Download the loading svg first so there is no display delay when the overlay loads after the login button is clicked
    $('form#my_casino_login_form_popup').append('<img src="/wp-content/themes/chickasaw/images/loader.svg" class="d-none" />');
    
    render_popover_link_account_forms_recaptcha();

    // Perform AJAX login on form submit
    $('form#my_casino_login_form_popup').on('submit', function(e) {

        var validatedForm = $("#my_casino_login_form_popup").validate();
        if ( !validatedForm.form() ) return false;

        // $('form#my_casino_login_form_popup p.status').show().text(ajax_login_object.loadingMessage);
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: global_vars.ajax_url,
            data: { 
                'action': 'ajaxlogin', //calls wp_ajax_nopriv_ajaxlogin
                'username': $('form#my_casino_login_form_popup input[name="username"]').val(), 
                'password': $('form#my_casino_login_form_popup input[name="password"]').val(), 
                'security': $('form#my_casino_login_form_popup input[name="_wpnonce"]').val(),
                'redirect_to': $('form#my_casino_login_form_popup input[name="redirect_to"]').val()
            },
            beforeSend : function(xhr) {
              $('#newcastle-user-menu-wrapper').prepend('<div class="loading-overlay d-flex align-items-center justify-content-center"><div class="loading-content d-flex flex-column text-center"><img src="/wp-content/themes/chickasaw/images/loader.svg" class="loader-svg" /><p></p></div></div>');
              $('.loading-overlay p').show().text(ajax_login_object.loadingMessage);
            },
            success: function(data) {
                // $('form#my_casino_login_form_popup p.status').text(data.message);
                if (data.success == true) {
                    $('.loading-overlay img').hide();
                    $('.loading-content').prepend('<i class="fa fa-check" aria-hidden="true"></i>');
                    $('.loading-overlay p').show().html(data.message);

                    if (typeof dataLayer != 'undefined') {
                      dataLayer.push({
                        event: 'loginEvent',
                        loginState: true
                      });
                    }

                    location.reload();

                    // $('form#my_casino_login_form_popup p.status').show().text('Logged in successfully');
                } else if (data.success == false) {
                  // console.log(data);
                  if (data.error_code == 2) { // Invalid Password
                    $('.loading-overlay p').show().html('Something went wrong.<br />Error: <span class="text-danger">Invalid Password</span>');
                    $('.loading-overlay .loading-content').append(
                      '<div class="text-center mx-3">'+
                      '<a href="#" class="btn cyan-button try-again">Try Again</a>'+
                      '<a href="/newcastle-account/forgot-password" class="btn cyan-button">Forgot Password?</a>'+
                      '</div>'+
                      '<p class="text-success mt-3">For security purposes, your account will be<br />locked after 3 failed login attempts.</p>'
                    );
                    try_again_button();
                  } else if (data.error_code == 1) { // User locked out
                    $('.loading-overlay p').show().html('<span class="text-danger">Your account has been locked due to<br />3 failed login attempts.</span>');
                    $('.loading-overlay .loading-content').append(
                      '<a href="/" class="btn cyan-button">Home</a>'+
                      '<p class="text-danger mt-3">Please check back in 24 hours.</p>'
                    );
                  } else {
                    $('.loading-overlay p').show().html(data.message);
                    $('.loading-overlay .loading-content').append(
                      '<a href="/" class="btn cyan-button">Home</a>'+
                      '<p class="mt-3">Please try again later.</p>'
                    );
                  }
                }
            }
        });
        e.preventDefault();
    });


    function try_again_button() {
      $('.loading-overlay .try-again').on(clickEventType, function(ev) {
        $('.loading-overlay').remove();
        ev.preventDefault();
      });
    }


    // Perform AJAX on the non-patron Reel Rewards Link Accounts header popup form submit
    $(document).on('submit', 'form#non_patron_club_passport_popup', function(e) {

      var validatedForm = $("#non_patron_club_passport_popup").validate();
      if ( !validatedForm.form() ) return false;

      var recaptcha_response = grecaptcha.getResponse(popupCaptchaId);
      if(recaptcha_response.length == 0){

        $('#non_patron_club_passport_popup .recaptcha-msg-error').text( "Please complete reCAPTCHA" );
        // if(!$('#non_patron_club_passport_popup .recaptcha-msg-error').hasClass( "error" ) ){
        //   $('#non_patron_club_passport_popup .recaptcha-msg-error').addClass( "error" );
        // }

        return false;

      }

      $.ajax({
            type: 'POST',
            dataType: 'json',
            url: global_vars.ajax_url,
            data: { 
                'action': 'my_casino_link_accounts_form', //calls wp_ajax_nopriv_my_casino_link_accounts_form
                'security': $('form#non_patron_club_passport_popup input[name="_wpnonce"]').val(),
                'member_number': $('form#non_patron_club_passport_popup input[name="member_number"]').val(),
                'pin': $('form#non_patron_club_passport_popup input[name="pin"]').val(),
                'zipcode': $('form#non_patron_club_passport_popup input[name="zipcode"]').val(),
                'g-recaptcha-response': $('form#non_patron_club_passport_popup .g-recaptcha-response').val(),
                'redirect_to': $('form#non_patron_club_passport_popup input[name="redirect_to"]').val()
            },
            beforeSend : function(xhr) {
              $('form#non_patron_club_passport_popup button').addClass('loading');
            },
            success: function(data) {
                if (data.success == true) {

                  store.set('ls_last_updated_at', moment().subtract(1, 'day'));
                  casino.account_type = 'patron';
                  update_casino_variable_and_local_storage(true, '#page');

                  $('form#non_patron_club_passport_popup button').removeClass('loading');
                  $('form#non_patron_club_passport_popup p.status').removeClass('error');
                  $('form#non_patron_club_passport_popup p.status').html('Your accounts are now linked');

                } else if (data.success == false) {
                  grecaptcha.reset(popupCaptchaId);
                  $('form#non_patron_club_passport_popup button').removeClass('loading');
                  $('form#non_patron_club_passport_popup p.status').addClass('error');
                  $('form#non_patron_club_passport_popup p.status').html(data.message);

                }
            }
        });

      e.preventDefault();
    });


    // Perform AJAX on the prospect Reel Rewards Link Accounts header popup form submit
    $(document).on('submit', 'form#prospect_club_passport_popup', function(e) {

      var validatedForm = $("#prospect_club_passport_popup").validate();
      if ( !validatedForm.form() ) return false;

      var recaptcha_response = grecaptcha.getResponse(popupCaptchaId);
      if(recaptcha_response.length == 0){

        $('#prospect_club_passport_popup .recaptcha-msg-error').text( "Please complete reCAPTCHA" );
        // if(!$('#prospect_club_passport_popup .recaptcha-msg-error').hasClass( "error" ) ){
        //   $('#prospect_club_passport_popup .recaptcha-msg-error').addClass( "error" );
        // }

        return false;

      }

      $.ajax({
            type: 'POST',
            dataType: 'json',
            url: global_vars.ajax_url,
            data: { 
                'action': 'my_casino_link_accounts_form', //calls wp_ajax_nopriv_my_casino_link_accounts_form
                'security': $('form#prospect_club_passport_popup input[name="_wpnonce"]').val(),
                'member_number': $('form#prospect_club_passport_popup input[name="member_number"]').val(),
                'pin': $('form#prospect_club_passport_popup input[name="pin"]').val(),
                'zipcode': $('form#prospect_club_passport_popup input[name="zipcode"]').val(),
                'g-recaptcha-response': $('form#prospect_club_passport_popup .g-recaptcha-response').val(),
                'redirect_to': $('form#prospect_club_passport_popup input[name="redirect_to"]').val()
            },
            beforeSend : function(xhr) {
              $('form#prospect_club_passport_popup button').addClass('loading');
            },
            success: function(data) {
                if (data.success == true) {

                  store.set('ls_last_updated_at', moment().subtract(1, 'day'));
                  casino.account_type = 'patron';
                  update_casino_variable_and_local_storage(true, '#page');

                  $('form#prospect_club_passport_popup button').removeClass('loading');
                  $('form#prospect_club_passport_popup p.status').removeClass('error');
                  $('form#prospect_club_passport_popup p.status').html('Your accounts are now linked');

                } else if (data.success == false) {
                  grecaptcha.reset(popupCaptchaId);
                  $('form#prospect_club_passport_popup button').removeClass('loading');
                  $('form#prospect_club_passport_popup p.status').addClass('error');
                  $('form#prospect_club_passport_popup p.status').html(data.message);

                }
            }
        });

      e.preventDefault();
    });

    if ( jQuery('#my-newcastle-menu .js-my-newcastle-link > a').hasClass('logged-in') ) {
      $('.my-newcastle-link .popover .arrow').addClass('logged-in');
      $('.my-riverwind-link .popover').addClass('logged-in');
    }

  });

  // Perform AJAX on the Change Password form submit
  $(document).on('submit', 'form#my_casino_change_password_form', function(e) {

    var validatedForm = $("#my_casino_change_password_form").validate();
    if ( !validatedForm.form() ) return false;

    $.ajax({
      type: 'POST',
      dataType: 'json',
      url: global_vars.ajax_url,
      data: { 
        'action': 'my_casino_change_password_form', //calls wp_ajax_nopriv_my_casino_change_password_form
        'security': $('form#my_casino_change_password_form input[name="_wpnonce-password"]').val(),
        'current_password': $('form#my_casino_change_password_form input[name="current_password"]').val(),
        'new_password': $('form#my_casino_change_password_form input[name="new_password"]').val(),
        'new_password_confirmation': $('form#my_casino_change_password_form input[name="new_password_confirmation"]').val(),
        'redirect_to': $('form#my_casino_change_password_form input[name="redirect_to"]').val()
      },
      beforeSend : function(xhr) {
        $('form#my_casino_change_password_form #change_password_response_message').html('');
        $('form#my_casino_change_password_form #change_password_error_message').html('');
        $('form#my_casino_change_password_form button.save-button').addClass('loading').prop('disabled', true);
      },
      success: function(data) {
        if (data.success == true) {

          $('form#my_casino_change_password_form button.save-button').removeClass('loading').prop('disabled', false);
          $('#my-account-update-form').html(ejs.compile(jQuery('#tmpl-my-account-update-form').html())(casino_data));
          allow_account_update_form_editing();
          dob_calendar_datepicker();
          $('form#my_casino_change_password_form #change_password_response_message').html(' - ' + data.message);

          setTimeout(function(){ 
            $('form#my_casino_change_password_form #change_password_response_message').fadeOut(3000);
          }, 3000);

        } else if (data.success == false) {

          $('form#my_casino_change_password_form button.save-button').removeClass('loading').prop('disabled', false);
          $('#my-account-update-form').html(ejs.compile(jQuery('#tmpl-my-account-update-form').html())(casino_data));
          allow_account_update_form_editing();
          dob_calendar_datepicker();
          $('form#my_casino_change_password_form #change_password_error_message').html(' - ' + data.message);

        }
      }
    }).fail(function (jqXHR, textStatus, error) {
      $('form#my_casino_change_password_form button.save-button').removeClass('loading').prop('disabled', false);
      $('form#my_casino_change_password_form button.save-button').prop("disabled",null);
      $('form#my_casino_change_password_form #change_password_error_message').html('- Error Occurred - Please Try Again Later');
    });

    e.preventDefault();
  });


  // Perform AJAX on the Newcastle Account Update form submit
  $(document).on('submit', 'form#my_casino_update_account_form', function(e) {

    var validatedForm = $("#my_casino_update_account_form").validate();
    if ( !validatedForm.form() ) return false;

    var accountType = casino.account_type;
    // accountType = 'non-patron'; // For testing

    if ( accountType != 'patron' ) {

      $.ajax({
        type: 'POST',
        dataType: 'json',
        url: global_vars.ajax_url,
        data: { 
          'action': 'my_casino_update_account_form', //calls wp_ajax_nopriv_my_casino_update_account_form
          'security': $('form#my_casino_update_account_form input[name="_wpnonce"]').val(),
          'email': $('form#my_casino_update_account_form input[name="email"]').val(),
          'first_name': $('form#my_casino_update_account_form input[name="first_name"]').val(),
          'last_name': $('form#my_casino_update_account_form input[name="last_name"]').val(),
          'dob': $('form#my_casino_update_account_form input[name="dob"]').val(),
          'address': $('form#my_casino_update_account_form input[name="address"]').val(),
          'address2': $('form#my_casino_update_account_form input[name="address2"]').val(),
          'city': $('form#my_casino_update_account_form input[name="city"]').val(),
          'state': $('form#my_casino_update_account_form select[name="state"]').val(),
          'zip': $('form#my_casino_update_account_form input[name="zip"]').val(),
          'phone': $('form#my_casino_update_account_form input[name="phone"]').val(),
          'redirect_to': $('form#my_casino_update_account_form input[name="redirect_to"]').val()
        },
        beforeSend : function(xhr) {
          $('form#my_casino_update_account_form #update_account_response_message').html('');
          $('form#my_casino_update_account_form #update_account_error_message').html('');
          $('form#my_casino_update_account_form button.save-button').addClass('loading').prop('disabled', true);
        },
        success: function(data) {
          if (data.success == true) {

            var firstName = data.params.arg2;
            var lastName = data.params.arg3;
            var city = data.params.arg4;
            var state = data.params.arg5;
            var zip = data.params.arg6;
            var phone = data.params.arg7;
            var email = data.params.arg8;
            var dob = data.params.arg9;

            var storeData = store.get('ls_patron');

            storeData.data.email = email;
            storeData.data.firstName = firstName;
            storeData.data.lastName = lastName;
            storeData.data.city = city;
            storeData.data.state = state;
            storeData.data.zip = zip;
            storeData.data.phone = phone;
            storeData.data.dob = dob;

            store.set('ls_patron', storeData);

            casino.firstName = firstName;
            casino.lastName = lastName;
            casino.patron.firstName = firstName;
            casino.patron.lastName = lastName;
            casino.patron.city = city;
            casino.patron.state = state;
            casino.patron.zip = zip;
            casino.patron.phone = phone;
            casino.patron.email = email;
            casino.patron.dob = dob;
            
            casino_data.o = casino;
            
            casino_data_updated();

            $('form#my_casino_update_account_form button.save-button').removeClass('loading').prop('disabled', false);
            // $('#my-account-update-form').html(ejs.compile(jQuery('#tmpl-my-account-update-form').html())(casino_data));
            // allow_account_update_form_editing();
            // dob_calendar_datepicker();
            $('form#my_casino_update_account_form #update_account_response_message').html(" - " + data.message);

            setTimeout(function(){ 
              $('form#my_casino_update_account_form #update_account_response_message').fadeOut(3000);
            }, 3000);

          } else if (data.success == false) {

            $('form#my_casino_update_account_form button.save-button').removeClass('loading').prop('disabled', false);
            // $('#my-account-update-form').html(ejs.compile(jQuery('#tmpl-my-account-update-form').html())(casino_data));
            // allow_account_update_form_editing();
            // dob_calendar_datepicker();
            $('form#my_casino_update_account_form #update_account_error_message').html(" - " + data.message);

          }
        }
      }).fail(function (jqXHR, textStatus, error) {
        $('form#my_casino_update_account_form button.save-button').removeClass('loading').prop('disabled', false);
        $('form#my_casino_update_account_form button.save-button').prop("disabled",null);
        $('form#my_casino_update_account_form #update_account_error_message').html('Error Occurred - Please Try Again Later');
      });


    } else if ( accountType == 'patron' ) {

      $.ajax({
        type: 'POST',
        dataType: 'json',
        url: global_vars.ajax_url,
        data: { 
          'action': 'my_casino_patron_email_update', //calls wp_ajax_nopriv_my_casino_patron_email_update
          'security': $('form#my_casino_update_account_form input[name="_wpnonce"]').val(),
          'email': $('form#my_casino_update_account_form input[name="email"]').val(),
          'redirect_to': $('form#my_casino_update_account_form input[name="redirect_to"]').val()
        },
        beforeSend : function(xhr) {
          $('form#my_casino_update_account_form #update_account_response_message').html('');
          $('form#my_casino_update_account_form #update_account_error_message').html('');
          $('form#my_casino_update_account_form button.save-button').addClass('loading').prop('disabled', true);
        },
        success: function(data) {
          if (data.success == true) {

            var newEmail = data.email;

            var storeData = store.get('ls_patron');
            storeData.data.email = newEmail;
            store.set('ls_patron', storeData);
            casino.patron.email = newEmail;

            $('form#my_casino_update_account_form button.save-button').removeClass('loading').prop('disabled', false);
            $('#my-account-update-form').html(ejs.compile(jQuery('#tmpl-my-account-update-form').html())(casino_data));
            allow_account_update_form_editing();
            dob_calendar_datepicker();
            $('form#my_casino_update_account_form #update_account_response_message').html(" - " + data.message);

            setTimeout(function(){ 
              $('form#my_casino_update_account_form #update_account_response_message').fadeOut(3000);
            }, 3000);

          } else if (data.success == false) {

            $('form#my_casino_update_account_form button.save-button').removeClass('loading').prop('disabled', false);
            $('#my-account-update-form').html(ejs.compile(jQuery('#tmpl-my-account-update-form').html())(casino_data));
            allow_account_update_form_editing();
            dob_calendar_datepicker();
            $('form#my_casino_update_account_form #update_account_error_message').html(" - " + data.message);

          }
        }
      }).fail(function (jqXHR, textStatus, error) {
        $('form#my_casino_update_account_form button.save-button').removeClass('loading').prop('disabled', false);
        $('form#my_casino_update_account_form button.save-button').prop("disabled",null);
        $('form#my_casino_update_account_form #update_account_error_message').html('Error Occurred - Please Try Again Later');
      });

    }
    e.preventDefault();
  });


  function win_loss_statement_ajax() {
    jQuery.ajax({
        type: 'POST',
        dataType: 'json',
        url: global_vars.ajax_url,
        data: { 
            'action': 'win_loss_statement_call', //calls wp_ajax_nopriv_win_loss_statement_call
            'security': jQuery('form#win_loss_statement_form input[name="_wpnonce"]').val(),
            'year_request': jQuery('form#win_loss_statement_form select[name="year_request"]').val(),
            'redirect_to': jQuery('form#win_loss_statement_form input[name="redirect_to"]').val()
        },
        beforeSend : function(xhr) {
          jQuery('form#win_loss_statement_form button').addClass('loading');
          // jQuery('form#win_loss_statement_form .data-message').html('Loading...');
          jQuery('a.print-info').addClass('d-none');
          jQuery('.final-statement').addClass('d-none');
          jQuery('#no_statement_available').addClass('d-none');
          jQuery('span.amount').html('Loading...');
          jQuery('.year-cell').addClass('invisible');
        },
        success: function(data) {
            jQuery('span.year-request').html(data.year);
            jQuery('.year-cell').removeClass('invisible');
            jQuery('.my-account-panel__label').html('Your Statement');
            jQuery('#win_loss_statement_form .loading').addClass('d-none');
            jQuery('#year-select').removeClass('d-none');

            if (data.success == true) {

                jQuery('form#win_loss_statement_form button').removeClass('loading');
                // jQuery('.legal-notice').addClass('d-none');
                jQuery('a.print-info').removeClass('d-none');
                jQuery('.final-statement').removeClass('d-none');

                var amount_class = '';
                try {
                  if ( parseInt(data.winloss) < 0 ) {
                    amount_class = 'negative';
                  } else {
                    amount_class = 'positive';
                  }
                } catch(err) {
                  // ignore
                }

                jQuery('span.amount').html('<span class="'+amount_class+'">$' + data.winloss + '</span>');

            } else if (data.success == false) {

                var fixedMessage = data.message.replace(/\s+/g, '&nbsp;');

                jQuery('form#win_loss_statement_form button').removeClass('loading');
                jQuery('span.amount').html(fixedMessage);

                if ( data.error == 'error5' ) {
                  jQuery('#no_statement_available').html(data.message);
                  jQuery('#no_statement_available').removeClass('d-none');
                } else {
                  jQuery('a.print-info').removeClass('d-none');
                  jQuery('.final-statement').removeClass('d-none');
                }
            }
        }
    });
  }


  // Perform AJAX for Win Loss Statements
  if (jQuery('#win_loss_statements_page').is(':visible')) {
    $('head link[rel="stylesheet"]').last().after('<link rel="stylesheet" href="../../wp-content/themes/chickasaw/css/win-loss-print.css" type="text/css" media="print" />');

    // Select year form must be hidden with jquery, or ajax won't work if d-none bootstrap class is used
    $('#win_loss_statement_form').hide();

    // Auto submits the form on initial page load
    // win_loss_statement_ajax();

    $('#year-select').change(function() {
        if ( $(this).val() ) {
          $('#win_loss_statement_form .loading').removeClass('d-none');
          $('#year-select').addClass('d-none');
          win_loss_statement_ajax();
        }
    });

    $('form#win_loss_statement_form').on('submit', function(e) {
      win_loss_statement_ajax();
      e.preventDefault();
    });

    // Checkbox click
    $('.legal-notice input[type=checkbox]').on('change', function() {
      if ( $(this).prop('checked') ) {
        $('.legal-notice button').removeClass('disabled');
      } else {
        $('.legal-notice button').addClass('disabled');
      }
    });

    // Agree & Continue button
    $('.legal-notice button').on(clickEventType, function() {
      if ( !$(this).hasClass('disabled') ) {
        $('.legal-notice').addClass('d-none');
        $('#win_loss_statement_form').show();
        $('.please-select').removeClass('d-none');
        location.hash = '#win_loss_statements_page';
      }
    });
  }

  function link_accounts_re_captcha_verified(){
    $('#my_casino_link_accounts_form .recaptcha-msg-error').text('');
    $('#my_casino_link_accounts_form .recaptcha-msg-error').removeClass( "error" );
  } 

  window.link_accounts_re_captcha_verified = link_accounts_re_captcha_verified;


  // Perform AJAX on the Club Royal Link Accounts form submit
  $(document).on('submit', 'form#my_casino_link_accounts_form', function(e) {

    var validatedForm = $("#my_casino_link_accounts_form").validate();
    if ( !validatedForm.form() ) return false;

    var recaptcha_response = grecaptcha.getResponse(captchaId);

    if(recaptcha_response.length == 0){

      $('#my_casino_link_accounts_form .recaptcha-msg-error').text( "Please complete reCAPTCHA" );
      if(!$('#my_casino_link_accounts_form .recaptcha-msg-error').hasClass( "error" ) ){
        $('#my_casino_link_accounts_form .recaptcha-msg-error').addClass( "error" );
      }

      return false;

    }

    $.ajax({
          type: 'POST',
          dataType: 'json',
          url: global_vars.ajax_url,
          data: { 
              'action': 'my_casino_link_accounts_form', //calls wp_ajax_nopriv_my_casino_link_accounts_form
              'security': $('form#my_casino_link_accounts_form input[name="_wpnonce"]').val(),
              'member_number': $('form#my_casino_link_accounts_form input[name="member_number"]').val(),
              'pin': $('form#my_casino_link_accounts_form input[name="pin"]').val(),
              'zipcode': $('form#my_casino_link_accounts_form input[name="zipcode"]').val(),
              'g-recaptcha-response': $('form#my_casino_link_accounts_form .g-recaptcha-response').val(),
              'redirect_to': $('form#my_casino_link_accounts_form input[name="redirect_to"]').val()
          },
          beforeSend : function(xhr) {
            $('form#my_casino_link_accounts_form button').addClass('loading').prop('disabled', true);
          },
          success: function(data) {
              if (data.success == true) {

                store.set('ls_last_updated_at', moment().subtract(1, 'day'));
                casino.account_type = 'patron';
                update_casino_variable_and_local_storage(true, '#page');

              } else if (data.success == false) {
                grecaptcha.reset(captchaId);
                $('form#my_casino_link_accounts_form button').removeClass('loading').prop('disabled', false);
                $('form#my_casino_link_accounts_form .data-message').addClass('error');
                $('form#my_casino_link_accounts_form .data-message').html(data.message);

              }
          }
      });

    e.preventDefault();
  });

});
